var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isTag)?_c('div',[_vm._v(" "+_vm._s(_vm.displayText)+" ")]):_c('Tag',{attrs:{"type":_vm.tagType}},[_vm._v(" "+_vm._s(_vm.displayText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }